import React, { useState } from "react";
import PersonalInfo from "./PersonalInfo";
import AcademicData from "../components/employee/AcademicData";
import WorkExperience from "../components/employee/WorkExperience";
import EmergencyContacts from "../components/employee/EmergencyContacts";
import HealthCondition from "../components/employee/HealthCondition";
import AttachmentUpload from "../components/library/AttachmentUpload";
import BankDetails from "../components/employee/BankDetails";

const tabs = [
  "Personal Details",
  "Academic Qualifications",
  "Work Experience",
  "Documents",
  "Emergency Contact",
  "Health Conditions",
  "Bank Details",
];

const SelfService = () => {
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const userId = sessionStorage.getItem("employeeId");

  const renderTabContent = () => {
    switch (activeTab) {
      case "Personal Details":
        return (
          <div className="p-4">
            <PersonalInfo userId={userId} />
          </div>
        );
      case "Academic Qualifications":
        return (
          <div className="p-4">
            <AcademicData userId={userId} />
          </div>
        );
      case "Work Experience":
        return (
          <div className="p-4">
            <WorkExperience userId={userId} />
          </div>
        );
      case "Documents":
        return (
          <div className="p-4">
            <AttachmentUpload userId={userId} uploadedBy={userId} />
          </div>
        );
      case "Emergency Contact":
        return (
          <div className="p-4">
            <EmergencyContacts userId={userId} />
          </div>
        );
      case "Health Conditions":
        return (
          <div className="p-4">
            <HealthCondition userId={userId} />
          </div>
        );
      case "Bank Details":
        return (
          <div className="p-4">
            <BankDetails userId={userId} />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="relative flex min-h-screen flex-col bg-white group/design-root overflow-x-hidden">
      <div className="layout-container flex h-full grow flex-col">
        <div className="flex flex-1 justify-center py-5">
          <div className="layout-content-container flex flex-col flex-1">
            <h1 className="text-2xl font-bold text-[#111518] mb-6">
              Employee Self Service
            </h1>

            {/* Tabs */}
            <div className="flex flex-wrap gap-2 border-b border-[#dce1e5] mb-4">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-4 py-2 text-lg font-medium  font-bold ${
                    activeTab === tab
                      ? "border-b-2 border-black text-black"
                      : "text-black"
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className=" ">{renderTabContent()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelfService;
